<div class="container">
<div class="row ">
  <div class="col-md-4">
    <button mat-raised-button color="warn" (click)="runBulkAdmissionLogsCreation()">Generate Bulk Admission Logs!</button>
  </div>
</div>

<!-- Hospitals RTDB -> Firestore migration -->
<div class="container mt-4">
  <mat-card>
    <mat-card-header>
      <mat-card-title>🏥 Migrate Hospitals to Firestore</mat-card-title>
      <mat-card-subtitle>
        Copies the Realtime Database <code>Hospitals</code> node into the dev
        (<code>devHospitals</code>) and prod (<code>ALHospitals</code>) collections with identical data.<br/>
        <em>Safe to re-run — documents with the same id are overwritten.</em>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="mt-3">
      <button mat-raised-button color="warn" (click)="migrateHospitalsToFirestore()" [disabled]="isMigratingHospitals">
        <mat-icon>local_hospital</mat-icon>
        {{ isMigratingHospitals ? 'Migrating…' : 'Migrate Hospitals' }}
      </button>
      <p *ngIf="hospitalMigrationStatus" class="mt-3" style="white-space: pre-line; font-family: monospace;">{{ hospitalMigrationStatus }}</p>
    </mat-card-content>
  </mat-card>
</div>

<!-- Units RTDB -> Firestore -->
<div class="container mt-4">
  <mat-card>
    <mat-card-header>
      <mat-card-title>🏢 Migrate Units to Firestore</mat-card-title>
      <mat-card-subtitle>
        Copies the Realtime Database units (<code>ALUnits</code> → prod, <code>ALUnits2</code> → dev) into Firestore
        <code>&lt;collection&gt;/&lt;centre&gt;/units/&lt;unit&gt;</code>. Verify compares counts and fields per centre and reconciles
        units against children (report only).<br/>
        <em>Safe to re-run — the Realtime Database is never modified.</em>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="mt-3">
      <button mat-raised-button color="warn" (click)="migrateUnitsToFirestore()" [disabled]="isMigratingUnits || isVerifyingUnits">
        <mat-icon>apartment</mat-icon>
        {{ isMigratingUnits ? 'Migrating…' : 'Migrate Units' }}
      </button>
      <button mat-raised-button color="primary" class="ms-2" (click)="verifyUnitsMigration()" [disabled]="isMigratingUnits || isVerifyingUnits">
        <mat-icon>fact_check</mat-icon>
        {{ isVerifyingUnits ? 'Verifying…' : 'Verify Units' }}
      </button>
      <p *ngIf="unitMigrationStatus" class="mt-3" style="white-space: pre-line; font-family: monospace;">{{ unitMigrationStatus }}</p>
      <p *ngIf="unitVerifyStatus" class="mt-3" style="white-space: pre-line; font-family: monospace;">{{ unitVerifyStatus }}</p>
    </mat-card-content>
  </mat-card>
</div>
</div>

<!-- ✅ Admission Cycle Logs Backfill -->
<div class="container mt-4">
  <mat-card>
    <mat-card-header>
      <mat-card-title>🔄 Build Admission Cycle Logs</mat-card-title>
      <mat-card-subtitle>
        One-time backfill — reads all <code>ALChild</code> documents and creates one
        <strong>AdmissionCycle</strong> document per stay (admission + discharge pair) in
        <code>ALAdmissionCycles</code> collection.<br/>
        Each <code>ALChild</code> document is also updated with a <code>lastDocId</code>
        field pointing to the child's most recent cycle.<br/>
        <em>Safe to re-run — existing cycle documents are overwritten.</em>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="mt-3">
      <button mat-raised-button color="warn"
              (click)="runAdmissionCycleLogs()"
              [disabled]="isBuildingAdmissionCycles">
        <mat-icon>loop</mat-icon>
        {{ isBuildingAdmissionCycles ? 'Building…' : 'Build Admission Cycle Logs' }}
      </button>

      <div *ngIf="admissionCycleBuildStatus" class="mt-3">
        <p style="white-space: pre-line; font-family: monospace;">{{ admissionCycleBuildStatus }}</p>
        <mat-progress-bar *ngIf="isBuildingAdmissionCycles || admissionCycleBuildProgress > 0"
                          [mode]="isBuildingAdmissionCycles ? 'indeterminate' : 'determinate'"
                          [value]="admissionCycleBuildProgress"
                          style="margin-top: 8px;">
        </mat-progress-bar>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!-- ✅ Education Monthly Summary Backfill -->
<div class="container mt-4">
  <mat-card>
    <mat-card-header>
      <mat-card-title>📊 Build Education Monthly Summary</mat-card-title>
      <mat-card-subtitle>
        One-time backfill — reads all educationTest + educationGroupTest docs and writes
        pre-aggregated summary to <code>educationMonthlySummary</code> collection.
        Run once; new sessions maintain counters automatically.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="mt-3">
      <button mat-raised-button color="primary"
              (click)="buildEducationMonthlySummary()"
              [disabled]="isBuildingSummary">
        <mat-icon>summarize</mat-icon>
        {{ isBuildingSummary ? 'Building...' : 'Build Education Monthly Summary' }}
      </button>

      <div *ngIf="summaryBuildStatus" class="mt-3">
        <p style="white-space: pre-line; font-family: monospace;">{{ summaryBuildStatus }}</p>
        <mat-progress-bar *ngIf="isBuildingSummary || summaryBuildProgress > 0"
                          mode="determinate"
                          [value]="summaryBuildProgress"
                          style="margin-top: 8px;">
        </mat-progress-bar>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!-- ✅ Counselling Monthly Summary Backfill -->
<div class="container mt-4">
  <mat-card>
    <mat-card-header>
      <mat-card-title>📊 Build Counselling Monthly Summary</mat-card-title>
      <mat-card-subtitle>
        One-time backfill — reads all Counselling individual sessions, group sessions,
        follow-up assessments, and session reviews, then writes pre-aggregated summary
        to <code>counsellingMonthlySummary</code> collection.
        Run once; new sessions maintain counters automatically.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="mt-3">
      <button mat-raised-button color="accent"
              (click)="buildCounsellingMonthlySummary()"
              [disabled]="isBuildingCounsellingSummary">
        <mat-icon>summarize</mat-icon>
        {{ isBuildingCounsellingSummary ? 'Building...' : 'Build Counselling Monthly Summary' }}
      </button>

      <div *ngIf="counsellingSummaryBuildStatus" class="mt-3">
        <p style="white-space: pre-line; font-family: monospace;">{{ counsellingSummaryBuildStatus }}</p>
        <mat-progress-bar *ngIf="isBuildingCounsellingSummary || counsellingSummaryBuildProgress > 0"
                          mode="determinate"
                          [value]="counsellingSummaryBuildProgress"
                          style="margin-top: 8px;">
        </mat-progress-bar>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!-- ✅ Backfill: FollowUp Assessment isHighlight -->
<div class="container mt-4">
  <mat-card>
    <mat-card-header>
      <mat-card-title>⭐ Backfill FollowUp isHighlight</mat-card-title>
      <mat-card-subtitle>
        One-time backfill — scans all <code>EducationFollowUpAssessment</code> docs and sets
        <code>isHighlight=true</code> where the question <em>"Any highlighted points to be shared"</em>
        has answer <strong>Yes</strong>.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="mt-3">
      <button mat-raised-button color="accent"
              (click)="backfillFollowUpHighlight()"
              [disabled]="isBackfillingHighlight">
        <mat-icon>star</mat-icon>
        {{ isBackfillingHighlight ? 'Processing...' : 'Backfill FollowUp isHighlight' }}
      </button>

      <div *ngIf="highlightBackfillStatus" class="mt-3">
        <p style="white-space: pre-line; font-family: monospace;">{{ highlightBackfillStatus }}</p>
        <mat-progress-bar *ngIf="isBackfillingHighlight"
                          mode="indeterminate"
                          style="margin-top: 8px;">
        </mat-progress-bar>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<div class="container">
  <div class="row">
    <div class="col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>User UID</mat-label>O
        <input matInput [(ngModel)]="userUid" placeholder="Enter user UID">
      </mat-form-field>
    </div>
    <div class="col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>New Email</mat-label>
        <input matInput [(ngModel)]="newUserEmail" type="email" placeholder="Enter new email">
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <button mat-raised-button color="warn" (click)="changeUserEmail(userUid, newUserEmail)">Change Email</button>
      <button mat-raised-button color="warn" (click)="changeUserEmailModular(userUid, newUserEmail)">Change Email (Modular)</button>
    </div>
  </div>
</div>

<div class="container mt-4">
  <h3>Copy Firestore Collection</h3>
  <div class="row">
    <div class="col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Source Collection</mat-label>
        <input matInput [(ngModel)]="sourceCollection" placeholder="e.g., ALInventory">
      </mat-form-field>
    </div>
    <div class="col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Target Collection</mat-label>
        <input matInput [(ngModel)]="targetCollection" placeholder="e.g., ALInventory_Backup">
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <button mat-raised-button color="primary"
              (click)="copyCollection(sourceCollection, targetCollection)"
              [disabled]="!sourceCollection || !targetCollection">
        Copy Collection (Batch)
      </button>
      <button mat-raised-button color="accent"
              (click)="copyCollectionSequential(sourceCollection, targetCollection)"
              [disabled]="!sourceCollection || !targetCollection"
              class="ml-2">
        Copy Collection (Sequential)
      </button>
    </div>
  </div>
</div>

<div class="container mt-4">
  <h3>Download as JSON</h3>
  <div class="row">
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Collection Path</mat-label>
        <input matInput [(ngModel)]="downloadCollectionPath" placeholder="e.g., ALInventory">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Document ID</mat-label>
        <input matInput [(ngModel)]="downloadDocumentId" placeholder="e.g., ALBorivali">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Field Path (optional)</mat-label>
        <input matInput [(ngModel)]="downloadFieldPath" placeholder="e.g., products">
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <button mat-raised-button color="primary"
              (click)="downloadCollectionAsJson(downloadCollectionPath)"
              [disabled]="!downloadCollectionPath">
        Download Entire Collection
      </button>
      <button mat-raised-button color="accent"
              (click)="downloadDocumentAsJson(downloadCollectionPath, downloadDocumentId)"
              [disabled]="!downloadCollectionPath || !downloadDocumentId"
              class="ml-2">
        Download Full Document
      </button>
      <button mat-raised-button color="warn"
              (click)="downloadDocumentFieldAsJson(downloadCollectionPath, downloadDocumentId, downloadFieldPath)"
              [disabled]="!downloadCollectionPath || !downloadDocumentId || !downloadFieldPath"
              class="ml-2">
        Download Field Only
      </button>
    </div>
  </div>
</div>

<div class="container mt-4">
  <h3>Upload JSON</h3>
  <div class="row">
    <div class="col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Collection Path</mat-label>
        <input matInput [(ngModel)]="uploadCollectionPath" placeholder="e.g., ALInventory">
      </mat-form-field>
    </div>
    <div class="col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Document ID (for single document upload)</mat-label>
        <input matInput [(ngModel)]="uploadDocumentId" placeholder="e.g., ALBorivali">
      </mat-form-field>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-md-12">
      <mat-checkbox [(ngModel)]="uploadMergeData">
        Merge with existing data (instead of overwriting)
      </mat-checkbox>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <button mat-raised-button color="primary"
              (click)="triggerJsonUploadForDocument(uploadCollectionPath, uploadDocumentId, uploadMergeData)"
              [disabled]="!uploadCollectionPath || !uploadDocumentId">
        <mat-icon>upload_file</mat-icon> Upload JSON to Document
      </button>
      <button mat-raised-button color="accent"
              (click)="triggerJsonUploadForCollection(uploadCollectionPath, uploadMergeData)"
              [disabled]="!uploadCollectionPath"
              class="ml-2">
        <mat-icon>upload_file</mat-icon> Upload JSON to Collection (Batch)
      </button>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <small class="text-muted">
        <strong>Single Document:</strong> Upload JSON data to a specific document.<br>
        <strong>Collection:</strong> Upload JSON data to multiple documents in a collection.
      </small>
    </div>
  </div>
</div>

<div class="container mt-4">
  <h3>Inventory Migration (ALInventoryB → ALInventory)</h3>
  <div class="row">
    <div class="col-md-8">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Document ID to Migrate</mat-label>
        <input matInput [(ngModel)]="inventoryMigrationDocId" placeholder="e.g., ALBorivali">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <button mat-raised-button color="warn"
              (click)="copyAndFixInventoryDocument(inventoryMigrationDocId)"
              [disabled]="!inventoryMigrationDocId"
              style="margin-top: 8px;">
        <mat-icon>sync_alt</mat-icon> Copy & Fix SKUs
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <small class="text-muted">
        <strong>What this does:</strong><br>
        1. Fetches document from <code>ALInventoryB/&#123;documentId&#125;</code><br>
        2. Matches products by name with <code>ALProducts</code> collection<br>
        3. Updates 'sku' field to match ALProducts document IDs (lowercase only)<br>
        4. Rebuilds products map where <strong>key === sku</strong> (e.g., products["1055"].sku = "1055")<br>
        5. Saves corrected document to <code>ALInventory/&#123;documentId&#125;</code><br>
        <br>
        <strong class="text-danger">⚠ Note:</strong> This will overwrite the document in ALInventory if it already exists.
      </small>
    </div>
  </div>
</div>

<div class="container mt-4">
  <h3>Update ALProducts SKUs</h3>
  <div class="row">
    <div class="col-md-8">
      <p class="text-muted mb-2">
        Ensure all products in ALProducts have 'sku' and 'id' fields matching their document ID.
      </p>
    </div>
    <div class="col-md-4">
      <button mat-raised-button color="primary"
              (click)="updateALProductsSKUs()">
        <mat-icon>update</mat-icon> Update All Product SKUs
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <small class="text-muted">
        <strong>What this does:</strong><br>
        1. Fetches all documents from <code>ALProducts</code> collection<br>
        2. For each product, sets <code>sku = documentId</code> and <code>id = documentId</code><br>
        3. Removes any uppercase <code>SKU</code> field<br>
        4. Updates in batches for efficiency<br>
        <br>
        <strong>Example:</strong> ALProducts/1055 will have sku: "1055" and id: "1055"
      </small>
    </div>
  </div>
</div>

<div class="container mt-4">
  <h3>Fix ALInventory Product Keys</h3>
  <div class="row">
    <div class="col-md-8">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Document ID (optional - leave empty for all)</mat-label>
        <input matInput [(ngModel)]="inventoryUpdateDocId" placeholder="e.g., ALBorivali">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <button mat-raised-button color="accent"
              (click)="updateALInventoryProductKeys(inventoryUpdateDocId || undefined)"
              style="margin-top: 8px;">
        <mat-icon>build</mat-icon> Fix Product Map Keys
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <small class="text-muted">
        <strong>What this does:</strong><br>
        1. Fetches ALInventory document(s)<br>
        2. For each product in the products map, updates the key to match the sku value<br>
        3. Sets the <code>id</code> field to match the <code>sku</code> value<br>
        4. Removes uppercase <code>SKU</code> fields<br>
        5. Fixes mismatches like: products["1000"].sku = "1131" → products["1131"].sku = "1131", id = "1131"<br>
        <br>
        <strong>Example from your logs:</strong><br>
        • Lizol Disinfectant: Key 1000, id 592 → Key 1131, id 1131, sku 1131<br>
        • Verka Ghee CH: Key 1054 → Key 1055, id 1055, sku 1055<br>
        <br>
        <strong class="text-info">💡 Tip:</strong> Leave Document ID empty to update all centres at once.
      </small>
    </div>
<div class="row">
  <div class="col-md-2">
      <button mat-raised-button color="accent" (click)="bulkAddAgeInEducationSessions()">Update Age and Dob in Education Sessions</button>
  </div>
</div>
<!--<button mat-raised-button color="primary" (click)="bulksEditTssGroup()">TSS BULK EDIT</button>-->
  </div>
</div>

<!-- Counselling Documents Date Addition Section -->
<div class="container mt-4">
  <h3>Counselling Documents - Add Date Fields</h3>
  <div class="row">
    <div class="col-md-12">
      <div class="alert alert-info">
        <strong>What this does:</strong><br>
        1. Fetches all sessions from <code>Counselling/allSessions/sessions</code> to get date information<br>
        2. Fetches document records from <code>ALDocuments/Counselling/individualSessions</code><br>
        3. Matches document records with sessions using document ID (same as session ID)<br>
        4. Adds <code>date</code> and <code>dateAdded</code> fields to each document object in the <code>documents</code> array<br>
        5. Adds <code>date</code> and <code>dateAdded</code> fields at the root level (outside array) for easier querying<br>
        6. Uses the matching session's <code>date</code> field as the timestamp value<br>
        7. Processes in batches of 500 for efficiency<br>
        8. Skips document records where documents already have date fields<br>
        9. Skips document records that don't have a matching session with a date field<br>
        <br>
        <strong>Data Structure:</strong><br>
        • Sessions: <code>Counselling/allSessions/sessions/&#123;sessionId&#125;</code> → Contains <code>date</code><br>
        • Documents: <code>ALDocuments/Counselling/individualSessions/&#123;sessionId&#125;</code> → Contains <code>documents</code> array<br>
        • Link: Document record ID = Session ID<br>
        <br>
        <strong>Result Structure:</strong><br>
        <code>&#123; date: Timestamp, dateAdded: Timestamp, documents: [&#123; description, fileName, url, date, dateAdded &#125;] &#125;</code><br>
        <br>
        <strong class="text-warning">⚠️ Note:</strong> This is a bulk operation that will update multiple documents.
        Verify first before running the update!
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <button mat-raised-button color="warn" (click)="addDateToCounsellingDocuments()">
        <mat-icon>event</mat-icon>
        Backfill Date + Centre Info (Individual)
      </button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <small class="text-muted">
        <strong>Steps to use:</strong><br>
        1. Click "Verify Documents" to check how many sessions need date fields<br>
        2. Click "Add Date Fields" to perform the bulk update<br>
        3. Check console for detailed progress logs<br>
        <br>
        <strong>Example Output:</strong><br>
        • Sessions processed: 250<br>
        • Sessions updated: 180<br>
        • Sessions skipped (already have dates): 70<br>
      </small>
    </div>
  </div>
</div>

<!-- Group Session Documents Date Addition Section -->
<div class="container mt-4">
  <h3>Group Session Documents - Add Date Fields</h3>
  <div class="row">
    <div class="col-md-12">
      <div class="alert alert-info">
        <strong>What this does:</strong><br>
        1. Fetches all group sessions from <code>Counselling/allSessions/groupSessions</code> to get date information<br>
        2. Fetches document records from <code>ALDocuments/Counselling/groupSessions</code><br>
        3. Matches document records with group sessions using document ID (same as session ID)<br>
        4. Adds <code>date</code> and <code>dateAdded</code> fields to each document object in the <code>documents</code> array<br>
        5. Adds <code>date</code> and <code>dateAdded</code> fields at the root level (outside array) for easier querying<br>
        6. Uses the matching session's <code>date</code> field as the timestamp value<br>
        7. Processes in batches of 500 for efficiency<br>
        8. Skips document records where documents already have date fields<br>
        9. Skips document records that don't have a matching session with a date field<br>
        <br>
        <strong>Data Structure:</strong><br>
        • Sessions: <code>Counselling/allSessions/groupSessions/&#123;sessionId&#125;</code> → Contains <code>date</code><br>
        • Documents: <code>ALDocuments/Counselling/groupSessions/&#123;sessionId&#125;</code> → Contains <code>documents</code> array<br>
        • Link: Document record ID = Session ID<br>
        <br>
        <strong>Result Structure:</strong><br>
        <code>&#123; date: Timestamp, dateAdded: Timestamp, documents: [&#123; description, fileName, url, date, dateAdded &#125;] &#125;</code><br>
        <br>
        <strong class="text-warning">⚠️ Note:</strong> This is a bulk operation that will update multiple documents.
        Verify first before running the update!
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <button mat-raised-button color="warn" (click)="addDateToGroupSessionDocuments()">
        <mat-icon>event</mat-icon>
        Backfill Date + Centre Info (Group)
      </button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <small class="text-muted">
        <strong>Steps to use:</strong><br>
        1. Click "Verify Group Session Documents" to check how many sessions need date fields<br>
        2. Click "Add Date Fields" to perform the bulk update<br>
        3. Check console for detailed progress logs<br>
        <br>
        <strong>Example Output:</strong><br>
        • Group sessions processed: 150<br>
        • Sessions updated: 120<br>
        • Sessions skipped (already have dates): 30<br>
      </small>
    </div>
  </div>
</div>

<!-- Individual Session Documents - Add Centre Info Section -->
<div class="container mt-4">
  <h3>Individual Session Documents - Add Centre Info</h3>
  <div class="row">
    <div class="col-md-12">
      <div class="alert alert-success">
        <strong>What this does:</strong><br>
        1. Fetches all sessions from <code>Counselling/allSessions/sessions</code> to get centreCode and centreName<br>
        2. Fetches document records from <code>ALDocuments/Counselling/individualSessions</code><br>
        3. Matches document records with sessions using document ID (same as session ID)<br>
        4. Adds <code>centreCode</code> and <code>centreName</code> fields at the root level of each document record<br>
        5. Processes in batches of 500 for efficiency<br>
        6. Skips document records that already have centre info<br>
        <br>
        <strong>Result Structure:</strong><br>
        <code>{{ '{' }} centreCode: "ABC", centreName: "Example Centre", date: Timestamp, documents: [...] {{ '}' }}</code><br>
        <br>
        <strong class="text-primary">✨ Benefit:</strong> Allows faster photo gallery queries without fetching session metadata!
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <button mat-raised-button color="accent" (click)="addCentreInfoToGroupDocuments()">
        <mat-icon>location_on</mat-icon>
        Add Centre Info to Individual Session Documents
      </button>
    </div>
  </div>
</div>

<!-- Education Documents Date and Centre Info Addition Section -->
<div class="container mt-4">
  <h3>Education Documents - Add Date Fields & Centre Info</h3>
  <div class="row">
    <div class="col-md-12">
      <div class="alert alert-info">
        <strong>What this does:</strong><br>
        1. Fetches all sessions from <code>educationTest</code> collection to get date and centre information<br>
        2. Fetches document records from <code>ALDocuments/Education/individualSessions</code><br>
        3. Matches document records with sessions using document ID (same as session ID)<br>
        4. Adds <code>date</code> and <code>dateAdded</code> fields to each document object in the <code>documents</code> array<br>
        5. Adds <code>date</code>, <code>dateAdded</code>, <code>centreCode</code>, and <code>centreName</code> fields at the root level for easier querying<br>
        6. Uses the matching session's <code>sessionDate</code>, <code>centreCode</code>, and <code>centreName</code> fields<br>
        7. Processes in batches of 500 for efficiency<br>
        8. Skips document records where documents already have date fields and centre info<br>
        9. Skips document records that don't have a matching session with a sessionDate field<br>
        <br>
        <strong>Data Structure:</strong><br>
        • Sessions: <code>educationTest/{{ '{' }}sessionId{{ '}' }}</code> → Contains <code>sessionDate</code>, <code>centreCode</code>, <code>centreName</code><br>
        • Documents: <code>ALDocuments/Education/individualSessions/{{ '{' }}sessionId{{ '}' }}</code> → Contains <code>documents</code> array<br>
        • Link: Document record ID = Session ID<br>
        <br>
        <strong>Result Structure:</strong><br>
        <code>{{ '{' }} date: Timestamp, dateAdded: Timestamp, centreCode: "ABC", centreName: "Centre Name", documents: [{{ '{' }} description, fileName, url, date, dateAdded {{ '}' }}] {{ '}' }}</code><br>
        <br>
        <strong class="text-warning">⚠️ Note:</strong> This is a bulk operation that will update multiple documents.
        Verify first before running the update!
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <button mat-raised-button color="warn" (click)="addDateToEducationDocuments()">
        <mat-icon>event</mat-icon>
        Backfill Date & Centre Info (Education Individual)
      </button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <small class="text-muted">
        <strong>Steps to use:</strong><br>
        1. Click "Verify Education Documents" to check how many sessions need date fields and centre info<br>
        2. Click "Add Date Fields & Centre Info" to perform the bulk update<br>
        3. Check console for detailed progress logs<br>
        <br>
        <strong>Example Output:</strong><br>
        • Sessions processed: 300<br>
        • Sessions updated: 220<br>
        • Sessions skipped (already have dates): 80<br>
      </small>
    </div>
  </div>
</div>

<!-- ✅ Dev Seeding: Copy production data to dev collections -->
<div class="container mt-4">
  <mat-card>
    <mat-card-header>
      <mat-card-title>🧪 Seed Dev Collections from Production</mat-card-title>
      <mat-card-subtitle>
        Copies live production data into dev/test collections so the app can be tested locally
        without touching real records.<br/>
        <strong class="text-danger">⚠ Only run this in a dev/test environment.</strong>
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="mt-3">
      <!-- Step legend -->
      <div class="alert alert-info py-2 mb-3">
        <strong>What will be copied:</strong>
        <ol class="mb-0 mt-1" style="font-size: 13px;">
          <li>ALL <code>ALChild</code> docs &nbsp;→&nbsp; <code>devChild</code></li>
          <li>ALL <code>ALCentres</code> docs &nbsp;→&nbsp; <code>centres</code></li>
          <li>Latest 200 <code>educationTest</code> &nbsp;→&nbsp; <code>educationTesting</code></li>
          <li>Latest 200 <code>educationGroupTest</code> &nbsp;→&nbsp; <code>educationGroupTesting</code></li>
          <li>Latest 200 <code>Counselling/allSessions/sessions</code> &nbsp;→&nbsp; <code>counsellingTest/.../sessions</code></li>
          <li>Latest 200 <code>Counselling/allSessions/groupSessions</code> &nbsp;→&nbsp; <code>counsellingTest/.../groupSessions</code></li>
          <li>ALL <code>EducationImpactReport</code> &nbsp;→&nbsp; <code>testEducationImpactReport</code></li>
          <li>ALL <code>ALUnits</code> (RTDB) &nbsp;→&nbsp; <code>ALUnits2</code> (RTDB)</li>
          <li>+ ~55 more collections (vehicles, tasks, notifications, logs, presentations,
              observations, follow-ups, permissions, etc.) — capped/ordered where a collection
              can grow large, and skipped automatically if a collection's prod and test names
              are the same. Per-collection results are logged to the browser console.</li>
        </ol>
      </div>

      <!-- Trigger button -->
      <button mat-raised-button color="warn"
              (click)="DevEntries()"
              [disabled]="isRunningDevEntries">
        <mat-icon>{{ isRunningDevEntries ? 'hourglass_top' : 'content_copy' }}</mat-icon>
        {{ isRunningDevEntries ? 'Seeding in progress…' : 'Run Dev Seeding' }}
      </button>

      <!-- Status + progress -->
      <div *ngIf="devEntriesStatus" class="mt-3">
        <p style="white-space: pre-line; font-family: monospace; font-size: 13px;">{{ devEntriesStatus }}</p>
        <mat-progress-bar
          *ngIf="isRunningDevEntries || devEntriesProgress > 0"
          [mode]="isRunningDevEntries && devEntriesProgress === 0 ? 'indeterminate' : 'determinate'"
          [value]="devEntriesProgress"
          style="margin-top: 8px;">
        </mat-progress-bar>
        <small *ngIf="devEntriesProgress > 0" class="text-muted">{{ devEntriesProgress }}% complete</small>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!-- Education Group Session Documents - Add Date & Centre Info Section -->
<div class="container mt-4">
  <h3>Education Group Session Documents - Add Date & Centre Info</h3>
  <div class="row">
    <div class="col-md-12">
      <div class="alert alert-warning">
        <strong>What this does:</strong><br>
        1. Fetches all group sessions from <code>educationGroupTest</code> to get date and centre information.<br>
        2. Fetches document records from <code>ALDocuments/Education/groupSessions</code>.<br>
        3. Matches documents with sessions by ID and adds <code>date</code>, <code>dateAdded</code>, <code>centreCode</code>, and <code>centreName</code> fields.<br>
        4. For group sessions, joins multiple centres into a single string (e.g., "Centre A, Centre B").<br>
        5. Processes in batches and skips records that are already complete.<br>
        <br>
        <strong>Result Structure:</strong><br>
        <code>&#123; date: Timestamp, centreCode: "ABC, XYZ", centreName: "Centre A, Centre B", documents: [...] &#125;</code><br>
        <br>
        <strong class="text-danger">⚠️ Note:</strong> This is a bulk operation. Verify first before running the update!
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <button mat-raised-button color="warn"
              (click)="addDateAndCentreInfoToEducationGroupDocuments()"
              [disabled]="isBackfillingEduGroupDocs">
        <mat-icon>event</mat-icon>
        {{ isBackfillingEduGroupDocs ? 'Backfilling...' : 'Backfill Date & Centre Info (Education Group)' }}
      </button>
      <div *ngIf="eduGroupDocBackfillStatus" class="mt-2">
        <small>{{ eduGroupDocBackfillStatus }}</small>
      </div>
    </div>
  </div>
</div>
